import { type LoaderArgs } from "@client/window";
import Deferred from "@common/lib/deferred";

import "./loader.less";

const getConfig = (style: number, iconColor: string) => {
  switch (style) {
    case 1:
      return {
        loadingInnerHTML: `<div class="material-icon"><div class="spinner"><div class="right-side"><div class="bar"></div></div><div class="left-side"><div class="bar"></div></div></div></div>`,
        iconColor: `.spinner .bar {border-color: ${iconColor};} .spinner .bar:after {background: ${iconColor};}`
      };
    case 2:
      return {
        loadingInnerHTML: `<div class="loader-inner ball-grid-pulse"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>`,
        iconColor: `.ball-grid-pulse > div {background: ${iconColor} !important;}`
      };
    case 3:
      return {
        loadingInnerHTML: `<div class="loader01"></div>`,
        iconColor: `.loader01 {border-color: ${iconColor} transparent ${iconColor} ${iconColor} !important;} .loader01::after {background: ${iconColor} !important;}`
      };
    case 4:
      return {
        loadingInnerHTML: `<div class="loader-inner square-spin"><div></div></div>`,
        iconColor: `.square-spin > div {background: ${iconColor} !important;}`
      };
    case 5:
      return {
        loadingInnerHTML: `<div class="loader04"></div>`,
        iconColor: `.loader04:after {background: ${iconColor} !important;}`
      };
    case 6:
      return {
        loadingInnerHTML: `<div class="loader-inner ball-rotate"><div></div></div>`,
        iconColor: `.ball-rotate > div, .ball-rotate > div:after, .ball-rotate > div:before {background: ${iconColor} !important;}`
      };
    case 7:
      return {
        loadingInnerHTML: `<div class="loader-inner cube-transition"><div></div><div></div></div>`,
        iconColor: `.cube-transition > div {background: ${iconColor} !important;}`
      };
    case 8:
      return {
        loadingInnerHTML: `<div class="loader-inner ball-zig-zag"><div></div><div></div></div>`,
        iconColor: `.ball-zig-zag > div {background: ${iconColor} !important;}`
      };
    case 9:
      return {
        loadingInnerHTML: `<div class="loader-inner ball-triangle-path"><div></div><div></div><div></div></div>`,
        iconColor: `.ball-triangle-path > div {background: ${iconColor} !important; border-color: ${iconColor} !important;}`
      };
    case 10:
      return {
        loadingInnerHTML: `<div class="loader-inner line-scale"><div></div><div></div><div></div><div></div><div></div></div>`,
        iconColor: `.line-scale > div {background: ${iconColor} !important;}`
      };
    case 11:
      return {
        loadingInnerHTML: `<div class="loader-inner ball-scale-multiple"><div></div><div></div><div></div></div>`,
        iconColor: `.ball-scale-multiple > div {background: ${iconColor} !important;}`
      };
    case 12:
      return {
        loadingInnerHTML: `<div class="loader-inner ball-pulse-sync"><div></div><div></div><div></div></div>`,
        iconColor: `.ball-pulse-sync > div {background: ${iconColor} !important;}`
      };
    case 13:
      return {
        loadingInnerHTML: `<div class="loader-inner ball-beat"><div></div><div></div><div></div></div>`,
        iconColor: `.ball-beat > div {background: ${iconColor} !important;}`
      };
    case 14:
      return {
        loadingInnerHTML: `<div class="loader-inner line-scale-pulse-out-rapid"><div></div><div></div><div></div><div></div><div></div></div>`,
        iconColor: `.line-scale-pulse-out-rapid > div {background: ${iconColor} !important;}`
      };
    case 15:
      return {
        loadingInnerHTML: `<div class="loader-inner ball-scale-ripple-multiple"><div></div><div></div><div></div></div>`,
        iconColor: `.ball-scale-ripple-multiple > div {border-color: ${iconColor} !important;}`
      };
    case 16:
      return {
        loadingInnerHTML: `<div class="loader-inner ball-spin-fade-loader"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>`,
        iconColor: `.ball-spin-fade-loader > div {background: ${iconColor} !important;}`
      };
    case 17:
      return {
        loadingInnerHTML: `<div class="loader-inner line-spin-fade-loader"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>`,
        iconColor: `.line-spin-fade-loader > div {background: ${iconColor} !important;}`
      };
    case 18:
      return {
        loadingInnerHTML: `<div class="loader-inner pacman"><div></div><div></div><div></div><div></div><div></div></div>`,
        iconColor: `
        .pacman > div:nth-child(3),
        .pacman > div:nth-child(4),
        .pacman > div:nth-child(5),
        .pacman > div:nth-child(6) 
          {background: ${iconColor} !important;}

        .pacman > div:first-of-type,
        .pacman > div:nth-child(2)
          {border-color: ${iconColor} transparent ${iconColor} ${iconColor} !important;} `
      };
    case 19:
      return {
        loadingInnerHTML: `<div class="loader-inner ball-grid-beat"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>`,
        iconColor: `.ball-grid-beat > div {background: ${iconColor} !important;}`
      };
    case 20:
      return {
        loadingInnerHTML: `<div class="single9"></div>`,
        iconColor: `.single9:before {background-color: ${iconColor} !important;}`
      };
    default:
      return {
        loadingInnerHTML: `<div class="material-icon"><div class="spinner"><div class="right-side"><div class="bar"></div></div><div class="left-side"><div class="bar"></div></div></div></div>`,
        iconColor: `.spinner .bar {border-color: ${iconColor} !important;} .spinner .bar:after {background: ${iconColor} !important;}`
      };
  }
};

let deferred = new Deferred();
const loader = {
  show: (args: LoaderArgs) => {
    if (!$.fn["animsition"]) {
      console.error("PageLoader requires 'animsition' plugin");
      return;
    }

    const loader = getConfig(args.style, args.color);
    if (!loader) return;

    deferred = new Deferred();

    if (args.style !== 10) {
      $("body").attr("data-icon", args.style);
    }

    $("body").attr("data-icon-color", args.color);
    $("head").append(`<style type="text/css">${loader.iconColor}</style>`);

    $("body")["animsition"]({
      inClass: "fadeIn",
      inDuration: args.inDuration,
      timeoutCountdown: 3000,
      loading: true,
      onLoadEvent: false,
      loadingParentElement: "body", //animsition wrapper element
      loadingClass: "animsition-loading",
      loadingInner: `<div class="loader">${loader.loadingInnerHTML}</div>`
    });

    if (!args.disableUnload) {
      window.addEventListener("beforeunload", () => {
        if (document.activeElement?.tagName === "A") {
          const activeAnchor = document.activeElement as HTMLAnchorElement;
          if (activeAnchor.protocol === "mailto:" || activeAnchor.protocol === "tel:") return;
        }

        $("body").css({ transition: `opacity ${args.outDuration}ms`, opacity: 0 });
      });
    }

    deferred.promise.finally(() => loader && $("body")["animsition"]("in"));
  },
  hide: () => {
    deferred.resolve();
  },
  promise: deferred.promise
};
export default loader;
